import { useContext, useEffect, useState } from 'react';
import { jwtVerify } from 'jose';

import { GlobalMobileContext } from '../contexts/globalMobileContext';
import SocketManagerMobile from '../utils/SocketManagerMobile';
import Mobile_LoginComponent from './Mobile_LoginComponent';
import Mobile_MainScreenComponent from './Mobile_MainScreenComponent';

const secretKey = new TextEncoder().encode("tekfinity-token");

function Mobile_App() {
    const {
        currentUser,
        socketToken,
        setSocketToken,
        setProjectIdParam,
        setConferenceIdParam,
        setTypeParam,
        setTopicIdParam
    } = useContext(GlobalMobileContext);

    const [userData, setUserData] = useState('');

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');

        if (!token) return;

        const verifyToken = async () => {
            try {
                const { payload } = await jwtVerify(token, secretKey);

                setSocketToken(payload.token);
                setProjectIdParam(payload.projectId);
                setConferenceIdParam(payload.conferenceId);
                setTypeParam(payload.type);
                setTopicIdParam(payload.topicId);
                setUserData(payload.infoUser ? payload.infoUser : '');

            } catch (err) {
                console.error("JWT verification failed:", err);
            }
        };

        verifyToken();
    }, []);

    return (
        <>
            {socketToken && <SocketManagerMobile />}
            {!currentUser && <Mobile_LoginComponent email={userData} />}
            {currentUser && <Mobile_MainScreenComponent />}
        </>
    );
}

export default Mobile_App;
